/**
 * Base Part class
 * Parts are components that can be attached to GameObjects
 */

import type { IPart } from './types';
import type { GameObject } from './GameObject';

/**
 * Abstract base class for all parts
 * Provides default implementations for lifecycle methods
 */
export abstract class Part implements IPart {
  abstract readonly name: string;
  parent: GameObject | null = null;

  /**
   * Called when this part is attached to a GameObject
   */
  attach(obj: GameObject): void {
    this.parent = obj;
  }

  /**
   * Called when this part is detached from a GameObject
   */
  detach(): void {
    this.parent = null;
  }

  /**
   * Handle an event fired on the parent GameObject
   * Override in subclasses to respond to specific events
   * @returns false to stop event propagation, true to continue
   */
  onEvent(_event: string, _data?: unknown): boolean {
    return true;
  }
}
